export function getIframeId(id: string) {
  return `tierIframe_${id}`;
}
